import * as firebase from 'firebase/app'
import { Analytics, getAnalytics } from 'firebase/analytics'
import { getMessaging, Messaging, onMessage } from 'firebase/messaging'

export let app: firebase.FirebaseApp
export let analytics: Analytics
export let messaging: Messaging

export async function initializeApp() {
  app = firebase.initializeApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: 'findoo-muensterland.firebaseapp.com',
    databaseURL: 'https://findoo-muensterland.firebaseio.com',
    projectId: 'findoo-muensterland',
    storageBucket: 'findoo-muensterland.appspot.com',
    messagingSenderId: '916561694792',
    appId: '1:916561694792:web:fbea9d7368940e13a8887d',
    measurementId: 'G-GQX0FTL2T1'
  })

  analytics = getAnalytics(app)
  messaging = getMessaging(app)

  onMessage(messaging, console.debug)
}
